<script setup lang="ts">
import { RouterLink } from "vue-router";
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <header class="sticky top-0 z-10 border-b-2 border-neutral-300 bg-white dark:border-neutral-800 dark:bg-neutral-950">
      <div class="mx-auto flex max-w-7xl items-stretch justify-between px-4">
        <RouterLink to="/" class="flex items-center gap-2 py-3 text-sm font-semibold uppercase tracking-widest">
          <font-awesome-icon icon="chart-line" class="text-[color:var(--color-accent)]" />
          <span>OSS Analytics</span>
        </RouterLink>
        <div class="flex items-stretch">
          <span class="border-l border-neutral-300 px-4 py-3 text-[11px] uppercase tracking-widest text-neutral-500 dark:border-neutral-800 dark:text-neutral-400">
            telemetry · v0.1
          </span>
          <a
            href="https://github.com/lukaszraczylo"
            target="_blank"
            rel="noopener noreferrer"
            class="flex items-center gap-1.5 border-l border-neutral-300 px-4 py-3 text-[11px] uppercase tracking-widest text-neutral-600 hover:text-neutral-900 dark:border-neutral-800 dark:text-neutral-400 dark:hover:text-white"
          >
            <font-awesome-icon :icon="['fab', 'github']" />
            <span>GitHub</span>
          </a>
        </div>
      </div>
    </header>

    <main class="mx-auto w-full max-w-7xl flex-1 px-4 py-4">
      <slot />
    </main>

    <footer class="border-t-2 border-neutral-300 bg-white dark:border-neutral-800 dark:bg-neutral-950">
      <div class="mx-auto flex max-w-7xl items-center justify-between px-4 py-2 text-[11px] uppercase tracking-widest text-neutral-500 dark:text-neutral-400">
        <p>Anonymous · Aggregated · No personal data</p>
        <p class="num">v0.1.0</p>
      </div>
    </footer>
  </div>
</template>
